module.exports = __webpack_public_path__ + "static/media/edit-btn.88cdeb41.svg";